import Symbol from "./Symbol";
import SymbolAnim from "./SymbolAnim";
import {pixiSetTimeout} from "../../framework/src/engine/pixi/pixiTimeout";
// import MadmaxCommanderBase from "../../framework/src/madmax/MadmaxCommanderBase";

class X248 extends Symbol{
    constructor(commander, speed) {
        super(commander, speed);
    }

    init() {
        //this.texture = PIXI.Texturse.from("symbol_Wild_particle.png");
        this.length = 1050;
        this.shortDelay = 1.86;
        this.longDelay = 2.5;

        this.longLoop = 1;
        this.shortLoop = 1;
    }

    animateX(symbol, multiplier, long) {
        if (long)
            return this.animateLong(symbol, multiplier);
        else
            return this.animateShort(symbol, multiplier);
    }

    animateShort(symbol, multiplier) {
        return new Promise (res => {
            pixiSetTimeout( this.shortDelay, () => {
                this.playSound(multiplier);
                let promises = [];
                promises.push(this.background(symbol));
                promises.push(this.flares(symbol));
                promises.push(this.diamonds(symbol));
                promises.push(this.X(symbol, multiplier));
                Promise.all(promises).then((values) => {
                    this.hideX(values).then(() => {
                        res(values);
                    });
                });
            });
        }).then((values) => {
            SymbolAnim.removeTween(values[1]);
        })
    }

    animateLong(symbol, multiplier) {
        return new Promise (res => {
            pixiSetTimeout( this.longDelay, () => {
                this.playSound(multiplier);
                let promises = [];
                promises.push(this.background(symbol));
                promises.push(this.flares(symbol));
                promises.push(this.diamonds(symbol));
                promises.push(this.X(symbol, multiplier, true));
                Promise.all(promises).then((values) => {
                    this.hideX(values).then(() => {
                        res(values);
                    });
                });
            });
        }).then((values) => {
            SymbolAnim.removeTween(values[1]);
        });
    }

    playSound(multiplier) {
        switch (multiplier) {
            case 2:
                if (!this.commander.audio.isPlaying("win_x2"))
                    this.commander.audio.playTrack("win_x2");
                break;
            case 4:
                if (!this.commander.audio.isPlaying("win_x4"))
                    this.commander.audio.playTrack("win_x4");
                break;
            case 8:
                if (!this.commander.audio.isPlaying("win_x8"))
                    this.commander.audio.playTrack("win_x8");
                break;
        }
    }

    background(symbol) {
        return new Promise(res => {
            let bg = SymbolAnim.createSprite(symbol.x, symbol.y, "x_background.png");
            this.layer.addChild(bg);
            bg.alpha = 0;

            createjs.Tween.get(bg)
                .wait(50 * this.speed)
                .to({alpha: 1}, 150 * this.speed, createjs.Ease.quadOut)
                .call(() => {
                    SymbolAnim.removeTween(bg)
                });

            res(bg);
        })
    }


    flares(symbol) {
        return new Promise(res => {
            let flares = SymbolAnim.createSprite(symbol.x, symbol.y, "x_flares.png", {x: 0.5, y: 0.48});
            flares.alpha = 0;

            this.layer.addChild(flares);
            createjs.Tween.get(flares)
                .wait(100 * this.speed)
                .to({alpha: 1}, 200 * this.speed, createjs.Ease.quadOut);

            createjs.Tween.get(flares, {loop: true})
                .to({rotation: 10*3.14}, 10*1000* this.speed, createjs.Ease.linear);

            res(flares);
        });
    }

    X(symbol, multiplier, long = false) {
        switch(multiplier) {
            case 2:
                return this.X2(symbol, long);
            case 4:
                return this.X4(symbol, long);
            case 8:
                return this.X8(symbol, long);
        }
    }

    X2(symbol, long) {
        return new Promise(res => {
            let x2 = SymbolAnim.createSprite(symbol.x, symbol.y, "x2.png");
            x2.scale.set(0,0);
            x2.rotation = -3.14;
            this.layer.addChild(x2);
            x2.name = "x2";

            createjs.Tween.get(x2.scale)
                .to({x: 1, y: 1}, 330*this.speed, createjs.Ease.linear)
                .call(() => {
                    SymbolAnim.removeTween(x2);
                    this.reflection(x2);
                    if (long)
                        this.xScale(x2, this.longLoop, res);
                    else
                        this.xScale(x2, this.shortLoop, res);
                });
            createjs.Tween.get(x2)
                .to({rotation: 0}, 330*this.speed, createjs.Ease.circOut)
                .call(() => {
                    SymbolAnim.removeTween(x2);
                });
        });
    }

    X4(symbol, long) {
        return new Promise(res => {
            let x4 = SymbolAnim.createSprite(symbol.x, symbol.y, "x4.png");
            x4.scale.set(0,0);
            x4.rotation = -3.14;
            this.layer.addChild(x4);
            x4.name = "x4";


            createjs.Tween.get(x4.scale)
                .to({x: 1, y: 1}, 330*this.speed, createjs.Ease.linear)
                .call(() => {
                    SymbolAnim.removeTween(x4);
                    this.reflection(x4);
                    if (long)
                        this.xScale(x4, this.longLoop, res);
                    else
                        this.xScale(x4, this.shortLoop, res);
                });

            createjs.Tween.get(x4)
                .to({rotation: 0}, 330*this.speed, createjs.Ease.circOut)
                .call(() => {
                    SymbolAnim.removeTween(x4);
                });
        });
    }

    X8(symbol, long) {
        return new Promise(res => {
            let x8 = SymbolAnim.createSprite(symbol.x, symbol.y, "x8.png");
            x8.scale.set(0,0);
            x8.rotation = -3.14;
            this.layer.addChild(x8);
            x8.name = "x8";


            createjs.Tween.get(x8.scale)
                .to({x: 1, y: 1}, 330*this.speed, createjs.Ease.linear)
                .call(() => {
                    SymbolAnim.removeTween(x8);
                    this.reflection(x8);
                    if (long)
                        this.xScale(x8, this.longLoop, res);
                    else
                        this.xScale(x8, this.shortLoop, res);
                });

            createjs.Tween.get(x8)
                .to({rotation: 0}, 330*this.speed, createjs.Ease.circOut)
                .call(() => {
                    SymbolAnim.removeTween(x8);
                });
        });
    }

    xScale(symbol, i, callback) {
        if (i === 0) {
            callback(symbol);
        } else {
            createjs.Tween.get(symbol.scale,{loop: true})
                .to({x: 0.95, y: 0.95}, 500*this.speed, createjs.Ease.linear)
                .to({x: 1, y: 1}, 500 * this.speed, createjs.Ease.linear)
                .call(() => {
                    if (--i < 1) {
                        SymbolAnim.removeTween(symbol.scale);
                        callback(symbol);
                    }
                });
        }
    }

    reflection(symbol) {
        let container = new PIXI.Container();
        let mask = SymbolAnim.createSprite(symbol.x, symbol.y, symbol.name+"_alpha.png");

        let reflection = SymbolAnim.createSprite(symbol.x-150, symbol.y, "overlay.png");
        container.mask = mask;
        container.addChild(mask);
        container.addChild(reflection);
        this.layer.addChild(container);

        createjs.Tween.get(reflection)
            .to({x: symbol.x+200}, 600*this.speed, createjs.Ease.linear)
            .call(() => {
                SymbolAnim.removeTween(reflection);
            })
    }

    diamonds(symbol) {
        return new Promise(res => {
            let promises = [];
            promises.push(this.diamond(symbol.x-50, symbol.y-50, 1, 0, 200));
            promises.push(this.diamond(symbol.x+25, symbol.y-80, 0.8, 0.5, 100));
            promises.push(this.diamond(symbol.x+80, symbol.y-70, 0.4, 1, 0));

            Promise.all(promises).then((diamonds) => {
                res(diamonds);
            })
        })
    }

    diamond(x, y, scale, rotation, delay) {
        return new Promise(res => {
            let diamond = SymbolAnim.createSprite(x,y, "diamond.png");
            diamond.scale.set(0,0);
            diamond.rotation = rotation;

            this.layer.addChild(diamond);

            createjs.Tween.get(diamond.scale)
                .wait((delay)*this.speed)
                .to({x: scale, y: scale}, 200*this.speed,createjs.Ease.linear)
                .to({x: scale-0.1, y: scale-0.1}, 100*this.speed,createjs.Ease.linear)
                .to({x: scale+0.05, y: scale+0.05}, 100*this.speed,createjs.Ease.linear)
                .to({x: scale, y: scale}, 100*this.speed,createjs.Ease.linear)
                .call(() => {
                    this.createSpark(x+20*scale, y-20*scale, 0.4);
                    SymbolAnim.removeTween(diamond.scale);
                    res(diamond);
                });
        })
    }

    hideX(values) {
        return new Promise(res => {
            let val = {val: 1};
            let v = {x: 0, y: 0};

            let baseX = [values[2][0].x,values[2][1].x,values[2][2].x];
            let baseY = [values[2][0].y,values[2][1].y,values[2][2].y];

            createjs.Tween.get(v)
                .to({x: -50, y: 75}, 260*this.speed, createjs.Ease.quadIn)
                .call(() => {
                    SymbolAnim.removeTween(v);
                })
                .addEventListener("change", () => {
                    values[2][0].position.set(baseX[0]-v.x, baseY[0]+v.y);
                    values[2][1].position.set(baseX[1]    , baseY[1]+v.y);
                    values[2][2].position.set(baseX[2]+v.x, baseY[2]+v.y);
                });

            createjs.Tween.get(val)
                .to({val: 0}, 260*this.speed, createjs.Ease.quadIn)
                .call(() => {
                    SymbolAnim.removeTween(val);
                    res();
                })
                .addEventListener("change", () => {
                    values[0].scale.set(val.val);
                    values[1].scale.set(val.val);
                    values[2][0].scale.set(val.val);
                    values[2][1].scale.set(val.val*0.8);
                    values[2][2].scale.set(val.val*0.4);
                    values[3].scale.set(val.val);
                });
        });
    }
}
export default X248;